module.exports = __webpack_public_path__ + "img/conversacion.7b58be5d.png";